// extracted by mini-css-extract-plugin
export var infoRow = "_tt-2";
export var labelContainer = "_tt-0";
export var rightInfo = "_tt-1";